import { Component, h, Host, Prop, Watch } from '@stencil/core';
import { ImageLink, ImageTile, MansoryImage } from './mansory';

@Component({
  tag: 'lilu-masonry',
  styleUrl: 'lilu-masonry.scss',
  shadow: true,
})
export class LiluMasonry {
  @Prop() rows: string;
  @Prop() internalRows: MansoryImage[];

  componentWillLoad() {
    this.parseMansoryRows();
  }

  @Watch('rows')
  parseMansoryRows() {
    if (this.rows !== undefined) {
      this.internalRows = JSON.parse(this.rows);
    }
  }

  renderRows() {
    const rows = [];

    this.internalRows?.forEach((row: MansoryImage) => {
      rows.push(this.renderMansoryImages(row.imageTiles));
    });

    return rows;
  }

  renderMansoryImages(imageTiles: ImageTile[]) {
    const images = [];

    imageTiles.forEach((imageTile: ImageTile) => {
      images.push(
        <div class={`item ${this.getImageSizeClass(imageTiles.length)} `}>
          <img src={imageTile.img} loading="lazy" width="100%" height="auto" draggable={false} />
          {imageTile.imgLinks?.length > 0 ? this.renderImageLinks(imageTile.imgLinks) : ''}
        </div>,
      );
    });
    return images;
  }

  getImageSizeClass(imageAmount: number): string {
    switch (imageAmount) {
      case 1:
        return 'large';
      case 2:
        return 'medium';
      case 3:
        return 'small';
      default:
        return 'small';
    }
  }

  renderImageLinks(imageLinks: ImageLink[]) {
    const links = [];

    imageLinks.forEach((imageLink: ImageLink) => {
      links.push(
        <lilu-image-product-link
          product-id={imageLink.productId}
          titletext={imageLink.titleText}
          producturl={imageLink.productUrl}
          price-type={imageLink.priceType}
          price={imageLink.price}
          oldprice={imageLink.oldPrice}
          addtocarttext={imageLink.addToCartText}
          top={imageLink.top}
          left={imageLink.left}
        ></lilu-image-product-link>,
      );
    });

    return links;
  }

  render() {
    return (
      <Host>
        <div class="grid">{this.renderRows()}</div>
      </Host>
    );
  }
}
